<template>
  <div class ="navbar-search">
    <div  v-if="tableData.cardStatus">
        <el-row
            v-loading="loading"
            element-loading-text="拼命诊断中"
            element-loading-spinner="el-icon-loading">
          <el-col :span="8">
            <p>
              <img src="@/assets/img/diagnostic_u190.png" >
              <span>SIM卡状态</span>
              <el-tooltip content="运营商侧的SIM状态" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </p>
          </el-col>
          <el-col :span="8"><p>{{ tableData.cardStatus }}</p></el-col>
          <el-col :span="8"><p>更新时间：{{ tableData.cardStatusUpdateTime }}</p></el-col>
        </el-row>

        <el-row v-if="!loading">
          <el-col :span="8">
            <p>
              <img src="@/assets/img/diagnostic_u217.png" >
              <span>网络状态</span>
              <el-tooltip content="运营商侧的SIM网络状态" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </p>
          </el-col>
          <el-col :span="8"><p>{{ tableData.gprsStatus }}</p></el-col>
          <el-col :span="8"><p>更新时间：{{ tableData.gprsStatusUpdateTime }}</p></el-col>
        </el-row>

        <el-row v-if="!loading">
          <el-col :span="8">
            <p>
              <img src="@/assets/img/diagnostic_u218.png" >
              <span>机卡绑定状态</span>
              <el-tooltip content="运营商侧的SIM机卡分离状态" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </p>
          </el-col>
          <el-col :span="8"><p>{{ tableData.lockStatus }}</p></el-col>
          <el-col :span="8"><p>更新时间：{{ tableData.lockStatusUpdateTime }}</p></el-col>
        </el-row>

        <el-row v-if="!loading">
          <el-col :span="8">
            <p>
              <img src="@/assets/img/diagnostic_u219.png" >
              <span>在线状态</span>
              <el-tooltip content="运营商侧的SIM在线状态" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </p>
          </el-col>
          <el-col :span="8"><p>{{ tableData.onlineDesc }}</p></el-col>
          <el-col :span="8"><p>更新时间：{{ tableData.onlineUpdateTime }}</p></el-col>
        </el-row>
    </div>

    <el-table v-if="tableData.cardStatus == null" :data="null" border :show-header="false" > </el-table>
  </div>


</template>
<script>
import {getDiagnosticResults, refreshDiagnosticResults} from "@/api/api.js";
export default {
  props: {
    iccid: {
      type: [String]
    }
  },
  data() {
    return{
      tableData: {
        cardStatus:"",
        cardStatusUpdateTime:"",
        gprsStatus:"",
        gprsStatusUpdateTime:"",
        lockStatus:"",
        lockStatusUpdateTime:"",
        onlineDesc:"",
        onlineUpdateTime:"",
      },
      loading: false,
    }
  },
  watch: {
    iccid() {
      this.initData();
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      this.loading = false;
      let params = {
        iccid:this.iccid
      };
      getDiagnosticResults(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data;
        }
      })
    },
    // 刷新诊断数据
    refreshDiagnosticData(){
      this.loading = true;
      this.tableData.cardStatus = "1";
      let params = {
        iccid:this.iccid
      };
      refreshDiagnosticResults(params).then(res => {
        if(res.data.code == 200){
          this.tableData = res.data.data;
          this.loading = false;
        }
      })
    },
  },
  created() {
    this.initData();
  }
};
</script>

<style scoped lang="less">
p {
  line-height: 80px;
}
img {
  vertical-align: middle;
  margin-right: 20px;
}
span {
  text-align: center;
}
</style>


